import { render, staticRenderFns } from "./LendingDialog.vue?vue&type=template&id=c0a4a4b0&"
import script from "./LendingDialog.vue?vue&type=script&lang=ts&"
export * from "./LendingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports